import React from "react"
import { Checkbox } from "@mui/material"

interface NotifyAttendeesCheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  ticketsCount: number
  rsvpsCount: number
}

export function NotifyAttendeesCheckbox({
  checked,
  onChange,
  ticketsCount,
  rsvpsCount,
}: NotifyAttendeesCheckboxProps) {
  const label =
    ticketsCount > 0 && rsvpsCount > 0
      ? `${ticketsCount} ticket holder${ticketsCount === 1 ? "" : "s"} and ${rsvpsCount} RSVP${rsvpsCount === 1 ? "" : "s"}`
      : ticketsCount > 0
        ? `${ticketsCount} ticket holder${ticketsCount === 1 ? "" : "s"}`
        : rsvpsCount > 0
          ? `${rsvpsCount} RSVP${rsvpsCount === 1 ? "" : "s"}`
          : null

  return (
    <div className="mb-2">
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        color="primary"
        style={{ padding: "0px 5px 0px 0px", verticalAlign: "top" }}
      />
      <label>Notify RSVPs &amp; Ticket Holders?</label>
      {label && (
        <div className="text-xs text-gray-500">
          {label}{" "}
          <span className="font-bold text-black-800">
            {checked ? "will be" : "will NOT be"}
          </span>{" "}
          notified of this update
        </div>
      )}
    </div>
  )
}
